import React, { Component } from "react"
import { Route, withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { getCurrentUser } from "redux/ducks/User"

import Home from "scenes/Home"
import About from "scenes/About"
import Help from "scenes/Help"

import CampNew from "scenes/Camp/CampNew"
import CampBilling from "scenes/Camp/CampBilling"
import CampCampersSearch from "scenes/Camp/CampCampersSearch"
import CampCampSearch from "scenes/Camp/CampCampSearch"
import CampDirectEmails from "scenes/Camp/CampDirectEmails"
import CampEdit from "scenes/Camp/CampEdit"
import CampInfoRequests from "scenes/Camp/CampInfoRequests"
import CampProfile from "scenes/Camp/CampProfile"

import UserCampers from "scenes/User/UserCampers"
import UserCampSearch from "scenes/User/UserCampSearch"
import UserEdit from "scenes/User/UserEdit"
import UserInfoRequests from "scenes/User/UserInfoRequests"
import StaffNew from "scenes/User/StaffNew"

import ForgotPassword from "scenes/ForgotPassword"
import Login from "scenes/Login/"

class Body extends Component {
  isLoading() {
    return localStorage.getItem("accessToken") && !this.props.currentUser
  }

  renderStaffRoutes() {
    if (this.props.currentUser && this.props.currentUser.role === "staff") {
      return (
        <div>
          <Route exact path="/" component={CampCampersSearch} />
          <Route exact path="/camps_search" component={CampCampSearch} />
          <Route exact path="/campers_search" component={CampCampersSearch} />
          <Route exact path="/info_requests" component={CampInfoRequests} />
          <Route
            exact
            path="/info_requests/:filter"
            component={CampInfoRequests}
          />
          <Route exact path="/direct_emails" component={CampDirectEmails} />
          <Route exact path="/edit" component={CampEdit} />
          <Route exact path="/billing" component={CampBilling} />
          <Route path="/camps/new" component={CampNew} />
          <Route exact path="/camps/:id" component={CampProfile} />
        </div>
      )
    }
  }

  renderGuardianRoutes() {
    if (this.props.currentUser && this.props.currentUser.role === "guardian") {
      return (
        <div>
          <Route exact path="/" component={UserCampSearch} />
          <Route exact path="/camps_search" component={UserCampSearch} />
          <Route exact path="/campers" component={UserCampers} />
          <Route exact path="/edit" component={UserEdit} />
          <Route exact path="/info_requests" component={UserInfoRequests} />
          <Route exact path="/camps/:id" component={CampProfile} />
        </div>
      )
    }
  }

  renderGuestRoutes() {
    if (!this.props.currentUser || !this.props.currentUser.role) {
      return (
        <div>
          <Route exact path="/" component={Home} />
          <Route path="/login" component={Login} />
          <Route path="/forgot_password" component={ForgotPassword} />
          <Route path="/staff/new" component={StaffNew} />
          <Route path="/camps/new" component={CampNew} />
        </div>
      )
    }
  }

  render() {
    const { currentUser, getCurrentUser } = this.props

    if (localStorage.getItem("accessToken") !== null && !currentUser) {
      getCurrentUser()
    }

    if (this.isLoading()) {
      return <div>Loading</div>
    }

    if (currentUser && currentUser.role === "staff") {
      if (!currentUser.camp) {
        return <CampNew />
      } else if (!currentUser.camp.attributes["subscribed-camps-and-campers"]) {
        return <CampBilling />
      }
    }

    return (
      <div>
        {this.renderStaffRoutes()}
        {this.renderGuardianRoutes()}
        {this.renderGuestRoutes()}
        <Route path="/about" component={About} />
        <Route path="/help" component={Help} />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

const mapDispatchToProps = dispatch => ({
  getCurrentUser: () => dispatch(getCurrentUser()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Body))



// WEBPACK FOOTER //
// ./src/scenes/App/Body.js